<template>
  <div id="error-page">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="4">
        <img src="/img/error_404.jpg">
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "error-404"
};
</script>

<style lang="scss">
</style>